import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedViewAllPhotosOption.meta';

export type UseTrackClickedViewAllPhotosOptionParams = {
  person_id: string;
  location: 'image-preview' | 'people-tab' | 'named-people-page' | 'unnamed-people-page' | 'people-settings';
};

export const useTrackClickedViewAllPhotosOption = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedViewAllPhotosOption = useCallback(
    (params: UseTrackClickedViewAllPhotosOptionParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedViewAllPhotosOption };
};
